module.exports = __webpack_public_path__ + "assets/img/Advanced_tit.547496da.png";